import React from 'react'
import { useRouter } from 'next/router'

import { Badge } from '@wartek-id/badge'

import LoadingSpinner from '../components/LoadingSpinner'
import DiskusiPersiapanForm from './DiskusiPersiapanForm'
import DiskusiPersiapanViewOnly from './DiskusiPersiapanViewOnly'
import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { usePelaksanaanPraktikKinerja } from 'app/KinerjaPenilikPegawaiPage/hooks/usePelaksanaanPraktikKinerja'
import { usePelaksanaanPraktikKinerjaSummary } from 'app/KinerjaPenilikPegawaiPage/hooks/usePelaksanaanPraktikKinerjaSummary'
import { Header } from 'app/KinerjaShared/components/Header'
import usePenilikPeriodGuard from 'app/KinerjaPenilikPegawaiPage/hooks/usePenilikPeriodGuard'

import type { PraktikKinerjaDiskusiPersiapanFormValue } from 'types/kinerja-penilik-pegawai'

export default function PelaksanaanDiskusiPersiapanPage() {
  const router = useRouter()

  // Entry Point Guards
  const [isPageLoading, setPageLoading] = React.useState(true)
  const { isPeriodSuccess, pelaksanaanGuard } = usePenilikPeriodGuard()

  const {
    penilikSummaryHookResult: {
      summaryFetchStatus: penilikSummaryFetchStatus,
      isPelaksanaanState,
    },

    formStatus,
    parsedFormValues,

    submitFormValues,
    submitStatus,

    isViewOnly,
    isAppeal,
  } = usePelaksanaanPraktikKinerja<PraktikKinerjaDiskusiPersiapanFormValue>({
    formName: 'diskusi_persiapan',
  })

  const {
    pelaksanaanPraktikKinerjaSummaryFetchStatus,
    pelaksanaanPraktikKinerjaSummary,
  } = usePelaksanaanPraktikKinerjaSummary()

  React.useEffect(() => {
    if (isPeriodSuccess && !pelaksanaanGuard.isOpen) {
      router.replace(PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH)
    } else if (
      isPeriodSuccess &&
      penilikSummaryFetchStatus === 'success' &&
      pelaksanaanPraktikKinerjaSummaryFetchStatus === 'success'
    ) {
      setPageLoading(false)
    }
  }, [
    isPeriodSuccess,
    penilikSummaryFetchStatus,
    pelaksanaanPraktikKinerjaSummaryFetchStatus,
    pelaksanaanGuard.isOpen,
    router,
  ])

  if (isPageLoading) {
    return (
      <div className="px-3 mx-auto max-w-7xl py-9">
        <LoadingSpinner />
      </div>
    )
  }

  if (!isPelaksanaanState) {
    router.replace(PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH)

    return null
  }

  const isLoading = formStatus === 'loading'
  const isFetched = formStatus === 'success'

  return (
    <div className="px-3 mx-auto max-w-7xl py-9">
      <Header
        title={
          <div className="flex items-center gap-x-3">
            Diskusi Persiapan
            {isViewOnly && !isAppeal && (
              <Badge variant="success">Selesai</Badge>
            )}
            {isAppeal && (
              <Badge variant="neutral">Perubahan sedang diajukan</Badge>
            )}
          </div>
        }
        className="mb-6"
      />

      {isViewOnly ? (
        <DiskusiPersiapanViewOnly
          formValues={parsedFormValues}
          pelaksanaanSummary={pelaksanaanPraktikKinerjaSummary}
          isLoading={isLoading}
          isFetched={isFetched}
        />
      ) : (
        <DiskusiPersiapanForm
          formValues={parsedFormValues}
          pelaksanaanSummary={pelaksanaanPraktikKinerjaSummary}
          isLoading={isLoading}
          isFetched={isFetched}
          onSubmitFormValues={submitFormValues}
          submitStatus={submitStatus}
        />
      )}
    </div>
  )
}
